var _path, _circle, _path2, _rect, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiServiceDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15C24.5 14.4477 24.9477 14 25.5 14H34.5C35.0523 14 35.5 14.4477 35.5 15V23.5C35.5 26.5376 33.0376 29 30 29C26.9624 29 24.5 26.5376 24.5 23.5V15Z",
    fill: "white",
    stroke: "#6092DB",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5.5,
    r: 4.5,
    stroke: "#6092DB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15C10.5 14.4477 10.9477 14 11.5 14H27.5C28.0523 14 28.5 14.4477 28.5 15V27C28.5 31.9706 24.4706 36 19.5 36C14.5294 36 10.5 31.9706 10.5 27V15Z",
    fill: "white",
    stroke: "#6092DB",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 7,
    width: 14,
    height: 14,
    rx: 3,
    fill: "white",
    stroke: "#6092DB",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 9H4.5V11H7.5V18H9.5V11H12.5V9Z",
    fill: "#6092DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 7.5C32.5 8.88071 31.3807 10 30 10C28.6193 10 27.5 8.88071 27.5 7.5C27.5 6.11929 28.6193 5 30 5C31.3807 5 32.5 6.11929 32.5 7.5Z",
    stroke: "#6092DB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiServiceDesk);
export default __webpack_public_path__ + "static/media/ai-service-desk.d8090be42b4bf7bf81c2bd0f98683df2.svg";
export { ForwardRef as ReactComponent };